import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon, CrownIcon, ImageIcon, PlayCircleIcon, LineChartIcon } from 'lucide-react';
const proKitBonuses = [{
  icon: ImageIcon,
  title: 'Guía visual ilustrada paso a paso',
  desc: 'Cada ejercicio del Megapack con ilustraciones claras de la postura correcta. Dejás de adivinar cómo se ejecuta.'
}, {
  icon: PlayCircleIcon,
  title: 'Rutinas guiadas para hacer sin el PDF',
  desc: 'Sesiones completas para seguir en el momento, sin frenar a leer instrucciones. Apretás play y arrancás.'
}, {
  icon: LineChartIcon,
  title: 'Planilla de seguimiento de progreso',
  desc: 'Registrás semana a semana qué hiciste y cómo te sentiste. Medís tu progreso real, no el percibido.'
}];
const withoutPack = ['Solo los PDFs para leer', 'Las dudas las resolvés buscando en Google', 'Ves el ejercicio escrito pero no cómo ejecutarlo', 'Seguís el plan sin saber si vas progresando bien'];
const withPack = ['Guía visual con cada ejercicio ilustrado paso a paso', 'Rutinas guiadas para hacer sin mirar el PDF', 'Planilla de seguimiento para medir tu progreso real', 'Sabés exactamente qué hacer cada día sin adivinar'];
export function ProKitBenefits() {
  return <section className="py-14 md:py-24 bg-slate-50" data-id="element-284">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-285">
        <div className="text-center mb-10 md:mb-14" data-id="element-286">
          <div className="inline-flex items-center gap-2 bg-brand-accent/10 border border-brand-accent/30 text-brand-accent rounded-full px-4 py-1.5 mb-4" data-id="element-287">
            <CrownIcon className="w-4 h-4" data-id="element-288" />
            <span className="text-xs md:text-sm font-bold uppercase tracking-wider" data-id="element-289">
              Exclusivo Pack Completo
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-extrabold text-slate-900 mb-3" data-id="element-290">
            Qué vas a obtener con el{' '}
            <span className="text-brand-accent" data-id="element-291">PACK COMPLETO</span>
          </h2>
          <p className="text-slate-500 text-sm md:text-base max-w-xl mx-auto" data-id="element-292">
            La diferencia entre leer un PDF y tener un sistema visual que te
            guía cada día
          </p>
        </div>

        {/* Comparison: Sin Pack vs Con Pack */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-10 md:mb-14" data-id="element-293">
          {/* Sin Pack */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border-2 border-slate-200 rounded-2xl p-5 md:p-7 relative" data-id="element-294">
            <div className="inline-flex items-center gap-2 bg-slate-100 text-slate-500 rounded-full px-3 py-1 mb-4" data-id="element-295">
              <XIcon className="w-3.5 h-3.5" strokeWidth={3} data-id="element-296" />
              <span className="text-[11px] md:text-xs font-bold uppercase tracking-wider" data-id="element-297">
                Si NO tenés Pack Completo
              </span>
            </div>
            <h3 className="font-bold text-lg md:text-xl text-slate-700 mb-4" data-id="element-298">
              Solo tenés el material en PDF
            </h3>
            <ul className="space-y-2.5" data-id="element-299">
              {withoutPack.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-slate-500 text-sm md:text-[15px]" data-id="element-300">
                  <XIcon className="w-4 h-4 text-slate-400 flex-shrink-0 mt-1" strokeWidth={3} data-id="element-301" />
                  <span data-id="element-302">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Con Pack — highlighted */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-dark border-2 border-brand-accent rounded-2xl p-5 md:p-7 relative shadow-2xl shadow-brand-accent/20" data-id="element-303">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-accent text-white text-[10px] md:text-xs font-black px-3 py-1 rounded-full uppercase tracking-wider shadow-lg flex items-center gap-1.5" data-id="element-304">
              <CrownIcon className="w-3 h-3" data-id="element-305" />
              Recomendado
            </div>
            <div className="inline-flex items-center gap-2 bg-brand-accent/15 text-brand-accent rounded-full px-3 py-1 mb-4 mt-2" data-id="element-306">
              <CheckIcon className="w-3.5 h-3.5" strokeWidth={3} data-id="element-307" />
              <span className="text-[11px] md:text-xs font-bold uppercase tracking-wider" data-id="element-308">
                Si tenés el Pack Completo
              </span>
            </div>
            <h3 className="font-bold text-lg md:text-xl text-white mb-4" data-id="element-309">
              Tenés un sistema visual completo
            </h3>
            <ul className="space-y-2.5" data-id="element-310">
              {withPack.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-slate-200 text-sm md:text-[15px]" data-id="element-311">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-brand-accent flex items-center justify-center mt-0.5" data-id="element-312">
                    <CheckIcon className="w-2.5 h-2.5 text-white" strokeWidth={4} data-id="element-313" />
                  </div>
                  <span data-id="element-314">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* 3 additional bonuses detail */}
        <div className="mb-8 text-center" data-id="element-315">
          <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-2" data-id="element-316">
            3 herramientas exclusivas del Pack Completo
          </h3>
          <p className="text-slate-500 text-sm md:text-base" data-id="element-317">
            Solo disponibles si elegís el Pack Completo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-318">
          {proKitBonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-5 md:p-6 border border-slate-200 shadow-sm hover:shadow-md hover:border-brand-accent/40 transition-all" data-id="element-319">
                <div className="flex items-center gap-3 mb-3" data-id="element-320">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-brand-accent/10 flex items-center justify-center flex-shrink-0" data-id="element-321">
                    <Icon className="w-5 h-5 md:w-6 md:h-6 text-brand-accent" data-id="element-322" />
                  </div>
                  <span className="text-[10px] md:text-xs font-black text-brand-accent uppercase tracking-wider" data-id="element-323">
                    Pack Completo #{index + 1}
                  </span>
                </div>
                <h4 className="font-bold text-slate-900 text-base md:text-lg mb-2 leading-snug" data-id="element-324">
                  {bonus.title}
                </h4>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-325">
                  {bonus.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}